import { Component, input } from '@angular/core';
import { SelectionButtonComponent } from '@shared/components/challenges/elements/selection-button/selection-button.component';
import { UnselectionButtonComponent } from '@shared/components/challenges/elements/unselection-button/unselection-button.component';
import { WinCardComponent } from '@shared/components/challenges/elements/win-card/win-card.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CampaignPhase } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeEightVariantConfig } from '@shared/models';
import {
  SafePipe,
  TransformUrlToBgPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant8',
  styleUrl: './variant8.component.scss',
  templateUrl: './variant8.component.html',
  imports: [
    SafePipe,
    IconComponent,
    WinCardComponent,
    TransformUrlToBgPipe,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant8Component extends FrequencyBaseClass {
  /** See {@link Variant6Component.previewSelected}. */
  previewSelected = input<boolean>(false);

  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeEightVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);
}
